import { getAuth } from "firebase/auth";

/**
 * Firebase'den geçerli ve güncel bir token alır
 * Token'da admin custom claim'i varsa bu bilgi token içinde olacaktır
 */
async function getValidFirebaseToken(): Promise<string | null> {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    // Token'ı force refresh ile al
    // Bu sayede backend'de yapılan admin claim değişiklikleri token'a yansır
    const token = await user.getIdToken(true); // force refresh = true
    localStorage.setItem("authToken", token);
    return token;
  }

  return null;
}

export default getValidFirebaseToken;
